/**
 * Created by Christal on 2018/5/15.
 * banner管理
 */
import * as API from './'
import querystring from 'querystring'

export default {
  // 分页查找标准库，并带检索
  findByPage: params => {
    return API.POST('/api/role/list', querystring.stringify(params))
  },
  Post: params => {
    return API.POST('/api/role', querystring.stringify(params))
  },
  // 更新Role
  Update: params => {
    return API.PUT('/api/role', querystring.stringify(params))
  },
  // 删除Role
  Delete: params => {
    return API.DELETE('/api/role', params)
  },
  // 不分页查找所有的角色
  findAll: params => {
    return API.GET('/api/role/findAll')
  },
  findById: params => {
    return API.GET('/api/role/findById')
  }
}



// WEBPACK FOOTER //
// ./src/api/api_role.js